export default __webpack_public_path__ + "static/N0195-cd59f15e9481c14f1691e4f64d26914d.png";